import './orchestration/commitDarkModeTheme';

export { default as DarkModeOption, isDarkModeEnabled } from './DarkModeOption';
